
export function checkSelectedCount() {
    let getList = document.querySelectorAll('#compare-list li[data-slot-comparison]');
    return getList.length;
}
